import { render } from "./ringingMsgChoose.vue?vue&type=template&id=a1d7ed3c&scoped=true"
import script from "./ringingMsgChoose.vue?vue&type=script&lang=js"
export * from "./ringingMsgChoose.vue?vue&type=script&lang=js"

import "./ringingMsgChoose.vue?vue&type=style&index=0&id=a1d7ed3c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\owner\\Desktop\\Project\\webrtc\\tsunagaru\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1d7ed3c"]])

export default __exports__